import script from "./BrandedNoteElement.vue.js?vue&type=script&lang=js!=!../../../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./BrandedNoteElement.vue?vue&type=script&lang=js"
export * from "./BrandedNoteElement.vue.js?vue&type=script&lang=js!=!../../../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./BrandedNoteElement.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__file',"src/SharedWeb/scripts/dynamic-components/render-engine/components/production/elements/text-element/BrandedNoteElement.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "17180966"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('17180966', __exports__)) {
    api.reload('17180966', __exports__)
  }
  
}


export default __exports__